<!--
 * @Author: DY
 * @Date: 2025-02-17 17:58:48
 * @LastEditTime: 2025-04-29 13:44:02
 * @Description: 产成品出库【仓储管理】
 * @FilePath: \ShiMo_Mobile\src\views\storage\finishedProductOutbound\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="finishedProductOutbound commonListStyles">
            <van-nav-bar left-arrow left-text="应用" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == '0'}" @click="listSwitch('0')">
                        未出库
                    </div>
                    <div :class="{'active': listType == '1'}" @click="listSwitch('1')">
                        已出库
                    </div>
                </template>
                <template #right>
                    <span class="iconfont sm-shaixuan11" @click="rightClickFun"></span>
                </template>
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" :immediate-check="false" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">出库单号：{{ item.outstock_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_13@2x.png" alt="">
                                            <span>出库类型：{{ item.outstock_type_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>来源单据编号：{{ item.source_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>客户名称：{{ item.client_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_32@2x.png" alt="">
                                            <span>库位名称：{{ item.grid_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_44@2x.png" alt="">
                                            <span>出库总重量（吨）：{{ item.total_outstock_weight }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>出库时间：{{ item.outstock_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>出库部门：{{ item.outstock_dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>出库人：{{ item.outstock_user_name }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.status == 0">
                                            <van-button plain type="danger" @click="toDetail(item, 'edit')">
                                                编辑
                                            </van-button>
                                            <van-button plain type="danger" @click="deleteOutboundOrder(item)">
                                                删除
                                            </van-button>
                                        </template>
                                        <template v-else>
                                            <van-button plain type="danger" @click="toDetail(item, 'see')">
                                                查看
                                            </van-button>
                                        </template>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <button class="addBtn iconfont sm-icon-test" @click="toDetail(null, 'new')"></button>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>出库单号</dt>
                            <dd>
                                <van-field v-model="params.searchKey" placeholder="输入出库单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>出库类型</dt>
                            <dd class="selectList">
                                <p
                                    v-for="(item, index) in outstockType"
                                    :key="`proceedsMode_${index}`"
                                    :class="{'active': item.Code === params.outstock_type}"
                                    @click="params.outstock_type = item.Code;"
                                >
                                    {{ item.Name }}
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>出库时间</dt>
                            <dd>
                                <van-field
                                    readonly
                                    v-model="params.deliveryTime"
                                    placeholder="选择出库时间"
                                    @click="calendarShow = true"
                                ></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>出库人</dt>
                            <dd>
                                <van-field v-model="params.OutstockUserName" placeholder="输入出库人"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>出库部门</dt>
                            <dd class="selectList">
                                <p
                                    v-for="(item, index) in outstockDeptList"
                                    :key="`proceedsMode_${index}`"
                                    :class="{'active': item.Code === params.outstock_dept_id}"
                                    @click="params.outstock_dept_id = item.Code;"
                                >
                                    {{ item.Name }}
                                </p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>客户名称</dt>
                            <dd>
                                <van-field v-model="params.client_names" placeholder="输入出库人"></van-field>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
            <van-calendar
                v-model="calendarShow"
                type="range"
                :min-date="minDate"
                :default-date="defaultDate"
                @confirm="onConfirmCalendar"
            ></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'finished-product-outbound',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'finished-product-outbound');
        }
        next();
    },
    data() {
        return {
            listType: '0',
            outstockType: [],
            outstockDeptList: [],
            params: {
                begin_time: '',
                end_time: '',
                searchKey: '',
                outstock_type: '',
                deliveryTime: '',
                OutstockUserName: '',
                outstock_dept_id: '',
                client_names: '',
            },
            calendarShow: false,
            defaultDate: [],
            minDate: new Date(2000, 0, 1),
            requestUrl: '/basicplatform/tabledata?code=for_app',
            tableCode: 'outstock_ccp',
            popupShow: false,
            requestData: {},
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    async created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.outstockType = await this.getOutstockType();
        this.outstockType.unshift({ Name: '全部', Code: '' });
        this.outstockDeptList = await this.getOutstockDeptList();
        this.outstockDeptList.unshift({ Name: '全部', Code: '' });
        this.params.outstock_dept_id = this.$takeTokenParameters('DeptId');
        // this.params.outstock_dept_id = this.outstockDeptList[1].Code;
        this.initPage();
    },
    mounted() {},
    computed: {},
    methods: {
        listSwitch(type) {
            this.listType = type;
            this.search();
        },
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirmCalendar(date) {
            const [start, end] = date;
            this.calendarShow = false;
            this.params.begin_time = this.formatDate(start);
            this.params.end_time = this.formatDate(end);
            this.params.deliveryTime = `${this.params.begin_time} ~ ${this.params.end_time}`;
        },
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                searchKey: this.params.searchKey,
                outstock_type: this.params.outstock_type,
                outstock_time_min: this.params.begin_time !== '' ? currencyFun.timeFormat(new Date(this.params.begin_time), 'yyyy-MM-dd HH:mm:ss') : '',
                outstock_time_max: this.params.end_time !== '' ? currencyFun.timeFormat(new Date(this.params.end_time), 'yyyy-MM-dd HH:mm:ss') : '',
                OutstockUserName: this.params.OutstockUserName,
                outstock_dept_id: this.params.outstock_dept_id,
                client_names: this.params.client_names,
                outstock_status: this.listType,
                product_category: '0',
            };
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.defaultDate = [];
            this.params.searchKey = '';
            this.params.outstock_type = '';
            this.params.deliveryTime = '';
            this.params.begin_time = '';
            this.params.end_time = '';
            this.params.OutstockUserName = '';
            this.params.outstock_dept_id = '';
            this.params.client_names = '';
        },
        rightClickFun() {
            this.popupShow = true;
        },
        toDetail(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'finishedProductOutboundForm',
                params: {
                    type,
                    id: item?.id || '',
                },
            });
        },
        deleteOutboundOrder(item) {
            this.$dialog.confirm({
                message: `确认删除出库单 \n${item.outstock_number} ？`,
            }).then(async () => {
                const res = await this.deleteRequest(item.id);
                if (res) {
                    this.$toast.success('删除成功。');
                    setTimeout(() => {
                        this.onRefresh();
                    }, 500);
                }
            });
        },
        // 获取出库类型请求
        getOutstockType() {
            return this.$axios.$get('/interfaceApi/sale/outstock/outstock_type_dic');
        },
        // 删除出库单请求
        deleteRequest(id) {
            return this.$axios.$get(`/interfaceApi/sale/outstock/outstock_ccp_delete?id=${id}`);
        },
        // 获取出库部门数据
        getOutstockDeptList() {
            return this.$axios.$get('/interfaceApi/sale/tenantcode/getbytype/warehouse_dept');
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.finishedProductOutbound
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
